/* eslint-disable
  import/no-extraneous-dependencies
*/
import './index.scss';

import React from 'react';
import createReactClass from 'create-react-class';

const Header = createReactClass({
  /**
   */

  getInitialState() {
    return {
      className: this.props.className || '',
    };
  },

  /**
   */

  render() {
    return (
      <div className={`m-signer-mobile-header ${this.state.className}`}>
        {this.props.children}
      </div>
    );
  },
});

export default Header;
